import React, {useState} from 'react';
import Icon from "../../system/components/icon";
import {copyToClipboard, mi} from "../../system/utils";
import {useDispatch} from "react-redux";
import {setMessage} from "../../system/app-slice";
import {InputText} from "primereact/inputtext";

function Index(props) {
    const dispatch = useDispatch();
    const [searchText, setSearchText] = useState("");
    return (
        <div className="h-full flex flex-column">
            <div className="p-2">
                <InputText className="w-full" value={searchText} onChange={(e)=>{setSearchText(e.target.value)}}/>
            </div>
            <div className="flex-1 w-full h-full flex flex-wrap gap-3 overflow-auto align-items-center justify-content-center pb-5 mt-2 h-fit">
                {
                    mi.filter(e=>e.includes(searchText)).map(m=>(<div onClick={()=>{copyToClipboard(`mi mi:${m}`); dispatch(setMessage({severity:"info", content:`${m} Icon Coppied`}))}} className="cursor-pointer h-fit flex flex-column align-items-center justify-content-center"><Icon icon={`mi mi:${m}`} className="text-2xl"/><span className="text-2xs"></span></div>))
                }
            </div>
        </div>

    );
}

export default Index;